import React, { forwardRef, memo, useEffect, useState } from 'react';

import { Box, Typography } from '@mui/material';
import { ConfirmErrorIcon } from 'app/shared/componentsRestyled/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

const getErrorWrapperStyles = ({ height, width }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '24px',
  height,
  width,
});

const Iframe = forwardRef(({ src, height, width, ...props }, ref) => {
  const [isBlocked, setIsBlocked] = useState(false);

  useEffect(() => {
    const handleSecurityPolicyViolation = e => {
      if (new URL(e.blockedURI).origin !== new URL(src).origin) {
        return;
      }

      setIsBlocked(true);
    };

    window.addEventListener('securitypolicyviolation', handleSecurityPolicyViolation);

    return () => {
      window.removeEventListener('securitypolicyviolation', handleSecurityPolicyViolation);
      setIsBlocked(false);
    };
  }, [src]);

  return isBlocked ? (
    <Box sx={getErrorWrapperStyles({ height, width })}>
      <ConfirmErrorIcon size={IconSize[64]} />
      <Typography variant="bold16">
        Access to this resource has been blocked by security policy.
      </Typography>
    </Box>
  ) : (
    <iframe height={height} ref={ref} src={src} width={width} {...props} />
  );
});

Iframe.propTypes = {
  src: PropTypes.string.isRequired,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default memo(Iframe);
